<div class="card card-primary">
  <div class="card-header">
    <h5>Marking Appearance Complete</h5>
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" name="closeBtn" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  
    <div class="card-body">
      <div class="form-group">
        <label>Message to Employer</label>
        <textarea class="form-control" [(ngModel)]="Message" row="3"></textarea>
      </div>
    </div>
    <div class="card-footer text-center">
      <button type="submit" (click)="CompleteAppearance()" class="btn btn-primary">Submit</button>
    </div>
  
</div>
